import { useState } from 'react'
import i18n from './react-i18next-config'


export default function ChangeLanguage() {

    const [language, setLanguage] = useState('zh-CN');
    const changeText = (t) => {
        setLanguage(t.target.value)
        i18n.changeLanguage(t.target.value==='en-US'?'en':'cn')
        // localStorage.setItem('i18nextLng', t.target.value==='en-US'?'en':'cn');
        console.log(t.target.value)
    }
    return (
        <div>
            <select className="custom-select " value={language} onChange={(e) => changeText(e)}>
                <option value="zh-CN">Chinese</option>
                <option value="en-US">English</option>
            </select>
        </div>
    )
}